import { Placement } from '@floating-ui/react-dom';
import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { ChatSubscriptionTypeEnum } from 'src/common/chat/subscription-type.enum';
import { DotMenuStrongIcon } from 'src/monet/icons';
import { InboxMessageStatusStack } from '../store';
import { DashboardInboxMenuOptions } from './options';

export const DashboardInboxMenuActions = ({ status }: { status: InboxMessageStatusStack }) => {
  const [keepMenuOpen, setKeepMenuOpen] = useState(false);
  const menuPlacementRef = useRef<Placement>();

  const onMenuOpened = (placement?: Placement) => {
    menuPlacementRef.current = placement;
    setKeepMenuOpen(true);
  };

  const onMenuClosed = () => {
    setKeepMenuOpen(false);
  };

  return (
    <div
      className={classNames(
        'flex grow-0 items-center space-x-sm transition opacity-0 group-hover:opacity-100',
        keepMenuOpen ? 'opacity-100' : 'opacity-0'
      )}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <DashboardInboxMenuOptions
        aliasUUID={status.aliasUUID}
        isSubscribed={status.subscription === ChatSubscriptionTypeEnum.ALIAS}
        placement={menuPlacementRef.current}
        renderMenuOrigin={(onClick) => (
          <div onClick={onClick}>
            <DotMenuStrongIcon />
          </div>
        )}
        onMenuOpen={onMenuOpened}
        onMenuClose={onMenuClosed}
      />
    </div>
  );
};
